import config from '@packages/config';
import { cached } from '@packages/shared';
import type { DrupalApiPromotion } from '../../../../interfaces';
import { fetcher } from '../../../utils';
import type { Promotion } from '../types';
import { mapDrupalPromotionToPromotion } from './mapDataToPromotion';

// fetch a promotion by code
export const fetchPromoData = async (
  code: { cart: string; texts: string },
  locale: string = 'de',
  callOwnApi?: boolean,
  testDate?: string,
): Promise<Promotion | undefined> => {
  // fetch from bucket only - the promotions are stored here after they are saved in drupal
  const fetchUrl = callOwnApi
    ? `/api/promotions/promotion/${code.texts}/?locale=${locale}`
    : config.promotionBanner.apiEndpoints.bucketPromotion
        .replace('<language>', locale.substring(0, 2))
        .replace('<code>', code.texts);
  return cached(
    [fetchUrl, code.cart, testDate].join(''),
    () =>
      fetcher<DrupalApiPromotion | Promotion>(fetchUrl).then((fetchedData) => {
        if ('data' in fetchedData) {
          return (
            fetchedData && mapDrupalPromotionToPromotion(fetchedData.data[0], code.cart, testDate)
          );
        }
        return fetchedData;
      }),
    5 * 60 * 1000,
  )();
};
